export default function () {
  if (document.querySelector('.single-post .ProductSticky')) {
    import(
      /* webpackChunkName: "product-sticky-module" */ './product-sticky'
    ).then((module) => {
      const ProductSticky = module.default
      ProductSticky()
    })
  }
}
